import React from "react";
import _ from "lodash";
import Select from "react-select";
import { NetworkAPI } from "apis";
import LoadingUI from "components/common/LoadingUI";

let CACHE_ITEMS = {};

class GAMInventorySizeSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      options: [],
      selectedValue: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const { selectedItems, networkId } = this.props;

    if (!networkId) {
      return;
    }

    const cachedItems = CACHE_ITEMS[networkId];
    let items = null;
    if (cachedItems && cachedItems.length > 0) {
      items = cachedItems;
    } else {
      this.setState({ isLoading: true });
      const { inventorySizes } = await NetworkAPI.getNetworkInventorySizes({
        networkId,
      });
      items = inventorySizes;
      CACHE_ITEMS[networkId] = inventorySizes;
      if (!inventorySizes) {
        throw new Error("Failed to find inventory sizes");
      }
    }

    const groupList = _.orderBy(items, this.getSortKey);

    const options = _.map(groupList, (item) => ({
      value: item,
      label: item,
    }));

    this.setState({
      isLoading: false,
      options,
      selectedValue: _.map(selectedItems, (item) =>
        _.find(options, { value: item })
      ).filter((d) => d),
    });
  }

  handleChange(options) {
    this.setState({
      selectedValue: options,
    });

    this.props.handleChanged(_.map(options, "value"));
  }

  getSortKey(str) {
    let type = "other";
    if (/^\d+x\d+$/.test(str)) type = "nxn";
    if (/^\d+x\d+v$/.test(str)) type = "nxnv";
    if (/^\d+:\d+$/.test(str)) type = "n:n";

    switch (type) {
      case "nxn": {
        const [a, b] = str.split("x").map(_.toNumber);
        return [1, a, b];
      }
      case "nxnv": {
        const [a, bWithV] = str.split("x");
        const b = _.toNumber(bWithV.replace("v", ""));
        return [2, _.toNumber(a), b];
      }
      case "n:n": {
        const [a, b] = str.split(":").map(_.toNumber);
        return [3, a, b];
      }
      default:
        return [4, str];
    }
  }

  render() {
    const { isReadonly = false } = this.props;
    const { options, selectedValue, isLoading } = this.state;

    return (
      <>
        {isLoading && isReadonly && <LoadingUI iconOnly={true} />}
        {isReadonly ? (
          selectedValue.map((item, i) => {
            return (
              <div
                key={i}
                className="mb-1 mr-1 inline-block bg-gray-200 px-1 text-gray-800"
              >
                {item.label}
              </div>
            );
          })
        ) : (
          <Select
            defaultValue={selectedValue}
            value={selectedValue}
            onChange={this.handleChange}
            options={options}
            isSearchable={true}
            isMulti={true}
            isLoading={isLoading}
            isDisabled={isReadonly}
          />
        )}
      </>
    );
  }
}

export default GAMInventorySizeSelector;
